import { APPLICATION_CHECK_STATUS } from '../../../../../config/constants'
import {
  blockClosingManagerNoteBody,
  buildBlockTimeline,
  clarificationsForCheckKind,
  eventsForCheckKind,
} from '../check-block-utils'

export function checkItemDiscussionHasContent({
  app,
  item,
  showEvents = false,
  showComposer,
}: ApplicationCheckItemContentArgs): boolean {
  if (showComposer) return true

  const clarifications = clarificationsForCheckKind({
    clarifications: app.clarifications,
    kind: item.kind,
    kindLabel: item.kind_label,
  })
  const events = showEvents ? eventsForCheckKind({ events: app.events, kind: item.kind }) : []
  const timeline = buildBlockTimeline({ clarifications, events, comments: item.comments ?? [] })
  if (timeline.length > 0) return true

  if (item.status !== APPLICATION_CHECK_STATUS.COMPLETED) return false

  const closingBody = blockClosingManagerNoteBody({ item, clarifications })
  return Boolean(closingBody) || (item.prepared_documents?.length ?? 0) > 0
}
